import type { ComponentChildren } from 'preact'
import { styled } from '../setup'
import { borders, colors, components, spacing, typography } from '../theme'

const CardContainer = styled('div')<{ maxWidth?: string }>`
  background: ${components.card.background};
  border: ${components.card.border};
  border-radius: ${components.card.borderRadius};
  padding: ${components.card.padding};
  width: 100%;
  max-width: ${(props) => props.maxWidth || 'none'};
`

const Title = styled('h2')`
  color: ${colors.textPrimary};
  font-size: ${typography.fontSize2xl};
  font-weight: ${typography.fontWeightSemibold};
  margin: 0 0 ${spacing.xl} 0;
  padding-bottom: ${spacing.md};
  border-bottom: ${borders.width} solid ${colors.border};
`

interface CardProps {
  children: ComponentChildren
  title?: string
  maxWidth?: string
}

export function Card({ children, title, maxWidth }: CardProps) {
  return (
    <CardContainer maxWidth={maxWidth}>
      {title && <Title>{title}</Title>}
      {children}
    </CardContainer>
  )
}
